import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { reduxForm } from 'redux-form';
import clientValidation from './clientValidation';
import * as ClientActions from 'redux/modules/clients';

import { NavDropdown, MenuItem, Label, Row, Col, Button } from 'react-bootstrap';
import i18next from 'i18next';


var Datetime = require('react-datetime');

export const fields = ['login', 'email', 'modules', 'rappel1', 'rappel2', 'etat',
  'expiry_date', 'phone', 'last_name', 'first_name', 'commercials'];

import { translate } from 'react-i18next';

@translate(['common'])
@connect(
  state => ({
    created: state.clients.created,
    clientCreatedError: state.clients.clientCreatedError,
    mods: state.modules.data,
  }),
  dispatch => bindActionCreators(ClientActions, dispatch)
)
@reduxForm({
  form: 'synchronousValidation',
  fields: fields,
  validate: clientValidation
})
export default class CreateClientForm extends Component {

  render() {
    const {
      fields:

      { login, email,
        modules, rappel1, rappel2,
        etat, expiry_date, phone, 
        last_name, first_name, commercials
      },

      handleSubmit,
      invalid,
      submitting,
      resetForm,
      createClient,
      values,
      clientCreatedError,
      created,
      mods, coms, t
    } = this.props;

    const styles = require('containers/Client/AddClient.scss');

    if (clientCreatedError != false) {
      var error = (
        <div className="alert alert-danger" role="alert">
          <span className="glyphicon glyphicon-exclamation-sign" aria-hidden="true"></span>
          {clientCreatedError}
        </div>);
    } else {
      var error = '';
    }

    if (created == true) {
      var success = (
        <div className="alert alert-success" role="alert">
          <span className="glyphicon glyphicon-exclamation-sign" aria-hidden="true"></span>
          {t('comClientForm.client_created')}
        </div>);
    } else {
      var success = '';
    }

    var labelClass = 'col-xs-3 control-label';
    var inputClass = 'col-xs-9 form-control';

    return (

      <div className="col-lg-6 col-xs-12 column">

        <form className="form-horizontal" >
          <div className={'form-group' + (login.touched && login.error ? ' has-error' : '')}>
            <label className={labelClass}>{t('main.username')}</label>
            <div className={'col-xs-' + (login.touched && login.error ? '5' : '8')}>
              <input type="text" className="form-control"  {...login} />
            </div>
            {login.touched && login.error && <div className="col-xs-3 help-block">{login.error}</div>}
          </div>

          <div className={'form-group' + (email.touched && email.error ? ' has-error' : '')}>
            <label className={labelClass}>{t('main.email')}</label>
            <div className={'col-xs-' + (email.touched && email.error ? '5' : '8')}>
              <input type="text" className="form-control" {...email} />
            </div>
            {email.touched && email.error && <div className="col-xs-3 help-block">{email.error}</div>}
          </div>

          <div className={'form-group' + (first_name.touched && first_name.error ? ' has-error' : '')}>
            <label className={labelClass}>{t('main.firstname')}</label>
            <div className={'col-xs-' + (first_name.touched && first_name.error ? '5' : '8')}>
              <input type="text" className="form-control" {...first_name} />
            </div>
            {first_name.touched && first_name.error && <div className="col-xs-3 help-block">{first_name.error}</div>}
          </div>


          <div className={'form-group' + (last_name.touched && last_name.error ? ' has-error' : '')}>
            <label className={labelClass}>{t('main.lastname')}</label>
            <div className={'col-xs-' + (last_name.touched && last_name.error ? '5' : '8')}>
              <input type="text" className="form-control" {...last_name} />
            </div>
            {last_name.touched && last_name.error && <div className="col-xs-3 help-block">{last_name.error}</div>}
          </div>

          <div className={'form-group' + (phone.touched && phone.error ? ' has-error' : '')}>
            <label className={labelClass}>{t('main.phone')}</label>
            <div className={'col-xs-' + (phone.touched && phone.error ? '5' : '8')}>
              <input type="text" className="form-control" {...phone} />
            </div>
            {phone.touched && phone.error && <div className="col-xs-3 help-block">{phone.error}</div>}
          </div>



          <div className={'form-group' + (modules.touched && modules.error ? ' has-error' : '')}>
            <label className={labelClass}>{t('main.modules')}</label>
            <div className="col-xs-8">
              <select className="form-control" name="modules" multiple {...modules}>
                {mods.map(module => <option key={module.id} value={module.id}>{module.name}</option>)}
              </select>
            </div>
          </div>

          <div className={'form-group' + (commercials.touched && commercials.error ? ' has-error' : '')}>
            <label className={labelClass}>{t('main.commercials')}</label>
            <div className="col-xs-8">
              <select className="form-control" name="commercials" {...commercials} multiple>
                {coms.map(com => <option key={com.id} value={com.id}>{com.login}</option>)}
              </select>
            </div>
          </div>



          <Row>
            <Col md={4} xs={12}>
              <label for="expiry_date">{t('main.contract_date')}</label>
              <Datetime id="expiry_date" style={{ 'width': '120px' }} {...expiry_date} locale={i18next.language}
                onChange={(date) => expiry_date.onChange(date)} ref="expiry_date" />
            </Col>


            <Col md={4} xs={12}>
              <label for="rappel1">{t('main.rappel1')}</label>
              <Datetime id="rappel1" style={{ 'width': '120px' }} {...rappel1} locale={i18next.language}
                onChange={(date) => rappel1.onChange(date)} ref="rappel1" />
            </Col>



            <Col md={4} xs={12}>
              <label for="rappel2">{t('main.rappel2')}</label>
              <Datetime for="rappel2" style={{ 'width': '120px' }} {...rappel2} locale={i18next.language}
                onChange={(date) => rappel2.onChange(date)} ref="rappel2"
              />
            </Col>


          </Row>

          <br />
          <Row>
            <Col md={6} xs={6}>
              <label for="etat">{t('main.state')}</label><br />
              <input type="radio" {...etat} value="1" checked={etat.value === '1'} /> {t('main.active')} &nbsp;
            <input type="radio" {...etat} value="0" checked={etat.value === '0'} /> {t('main.inactive')}
          </Col>
          </Row>



          <br/>
          <div className="form-group">
            <div className="">
              <button onClick={handleSubmit(() =>
                createClient(values)
              )} type="submit" className="btn btn-success" disabled={invalid || submitting}>
                <i className={'fa ' + (submitting ? 'fa-cog fa-spin' : 'fa-cloud')} /> {t('main.create_client')}
						  </button>
              <button type="button" className="btn btn-warning" style={{ margin: 10 }} disabled={submitting} onClick={resetForm}>
                {t('main.reset')}
		          </button>
            </div>
          </div>
          {error}

          {success}

        </form>

      </div>
    );
  }
}
